<template>
  <div v-if="!item.children" :style="{display: item.meta?.displayRoute ? 'none' : ''}">
    <a-menu-item v-if="!item.meta?.hidden" :key='`${basePath}`'>
      <template #icon v-if="item.meta?.icon">
        <!-- <svg-icon :icon-name="item.meta?.icon" /> -->
        <img :src="item.meta?.icon" alt="" width="20">
      </template>
      <router-link :to="item">{{ item.meta?.title || '' }}</router-link>
    </a-menu-item>
  </div>
  <div v-else>
    <a-menu-item v-if="isShow(item)" :key='`${basePath}`' :style=" {background: 'none',display: item.meta?.displayRoute ? 'none' : ''}">
      <template #icon v-if="onlyOne.meta?.icon">
        <!-- <svg-icon :icon-name="onlyOne.meta?.icon" /> -->
        <img :src="onlyOne.meta?.icon" alt="" width="20">
      </template>
      <router-link :to="onlyOne">{{ onlyOne.meta?.title || '' }}</router-link>
    </a-menu-item>
    <div v-else>
      <a-sub-menu :key="`${basePath}`" >
        <template #icon v-if="item.meta?.icon">
          <!-- <svg-icon :icon-name="item.meta?.icon" /> -->
          <img :src="item.meta?.icon" alt="" width="20">
        </template>
        <template #title >{{ item.meta?.title }}</template>
        <div v-for="(child, index) in item.children" :key="index">
          <item-menu :item="child" :basePath="`${basePath}/${child.path}`" style="margin-left: 8px;"></item-menu>
        </div>
      </a-sub-menu>
    </div>
  </div>

</template>

<script setup lang="ts">
import { ref } from 'vue';
import { RouteRecordRaw } from 'vue-router';
import { useRoute } from 'vue-router'

const props = defineProps(['item', 'basePath'])
const onlyOne = ref()
const isShow = (item: RouteRecordRaw) => {
  if(item.meta?.alwaysShow) {
    return false
  }
  const childrenArr = item.children ?? []
  const arr: RouteRecordRaw[] = []
  childrenArr.forEach((el: RouteRecordRaw) => {
    if (!el.meta?.hidden) {
      arr.push(el)
    }
  });
  if (arr.length === 0) {
    onlyOne.value = item
    return true
  } else if (arr.length === 1) {
    onlyOne.value = arr[0]
    return true
  }
  return false
}
</script>
<script lang="ts">
export default {
  name: 'ItemMenu.vue'
}
</script>
<style scoped>

.ant-menu-title-content a{
  color: #ffffff;
  opacity: 0.8;
}

.ant-menu-submenu-title .ant-menu-submenu-arrow{
  color: #ffffff;
}
:deep(.ant-menu-submenu .ant-menu) {
  background: none;
}
 :deep(.ant-menu-submenu-title) {
  color: #ffffff;
  opacity: 0.8;
}
.ant-menu-inline .ant-menu-item-selected{
  color: #ffae00;
  background: none;
}
.ant-menu-inline .ant-menu-item-selected .ant-menu-title-content a{
  color: #ffae00;
  font-weight: bold;
  opacity: 1;
}
.ant-menu-sub .ant-menu-item-selected .ant-menu-title-content a::before{
  width: 5px;
  height: 5px;
  top: 17px;
  left: 30px;
  background: #ffae00;
  border-radius: 5px;
}
:deep(.ant-menu-submenu-selected){
  color: #ffffff;
  background: none;
  opacity: 1;
  font-weight: bold;
}
:deep(.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected){
  background: none;
}
:deep(.ant-menu-submenu-active .ant-menu-submenu-title:hover){
  color: #ffffff;
}
:deep(.ant-menu-submenu-title .ant-menu-title-content:hover){
  color: #ffffff;
}
:deep(.ant-menu-item-selected::after) {
  border-right: 4px solid #ffae00 !important;
  border-radius: 6px 0 0 6px !important;
}
:deep(.ant-menu-submenu-active .ant-menu-submenu-title){
  color: #ffffff;
  background: none;
  opacity: 1;
}
:deep(.ant-menu-item a:hover){
  color: #ffffff;
  background: none;
  opacity: 1;
}
 :deep(.ant-menu-submenu-arrow){
  color: #ffffff;
}
:deep(.ant-menu-submenu-arrow::before){
  color: #ffffff;
}
/* 子菜单项的背景色 */
:deep(.ant-menu-vertical .ant-menu-item),
:deep(.ant-menu-vertical-left .ant-menu-item),
:deep(.ant-menu-vertical-right .ant-menu-item),
:deep(.ant-menu-inline .ant-menu-item) {
  background: transparent !important;
}

/* 鼠标悬停时的背景色 */
:deep(.ant-menu-item:hover),
:deep(.ant-menu-submenu-title:hover) {
  background: rgba(255, 255, 255, 0.1) !important; 
  color: #ffffff;
  opacity: 1;
}
</style>